import { Column } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import type { RequestTabId } from '../types'
import { RequestTabPanels } from './RequestTabPanels'

export const RequestPageContent = ({
  activeTab,
}: {
  activeTab: RequestTabId
}) => {
  const isExplore = activeTab === 'explore'

  const panel = <RequestTabPanels tab={activeTab} />

  if (isExplore) {
    return (
      <Column className="relative min-h-0 flex-1 overflow-hidden">{panel}</Column>
    )
  }

  return (
    <Column className="relative min-h-0 flex-1 overflow-hidden">
      <Column
        className={cn(
          'min-h-0 flex-1 overflow-auto pb-28 pt-6',
          activeTab === 'delivery' && 'items-center'
        )}
      >
        <Column className="mx-auto w-full max-w-5xl px-8 py-10 md:px-12 md:py-14">
          {panel}
        </Column>
      </Column>
    </Column>
  )
}
